/** Toggle guides visibility */
const DEBUG_USE_GUIDES = false;

export function showGuides(style) {
    if (DEBUG_USE_GUIDES) {
        return style;
    }
    return 'unset';
}